<style scoped lang="scss" type="text/scss">
    .team-container {
        display: flex;
        align-items: flex-start;

        .team-basic-info {
            width: 18rem;
            margin-right: 1rem;
        }
        .right-panel {
            flex: 1;
        }
    }
</style>

<template>
    <div class="team-container">
        <team-basic-info class="team-basic-info"></team-basic-info>
        <right-panel class="right-panel"></right-panel>
    </div>
</template>

<script>
    import TeamBasicInfo from '../sub-components/team-basic-info';
    import RightPanel from './right-panel';

    export default {
        name: '',
        components: {
            TeamBasicInfo,
            RightPanel
        },
        data () {
            return {};
        }
    };
</script>
